export default __webpack_public_path__ + "static/media/HASSAN_FR_SEQ17.d4d169ef.mp3";